import Vue from 'vue';

// @ts-ignore
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      dark: {
        primary: '#D5A900',
        secondary: '#7A822A',
        accent: '#D5A900',
        error: '#b71c1c',
      },
    },
  },
});
